import { render, staticRenderFns } from "./EditorialRanking.vue?vue&type=template&id=32507532&scoped=true&"
import script from "./EditorialRanking.vue?vue&type=script&lang=js&"
export * from "./EditorialRanking.vue?vue&type=script&lang=js&"
import style0 from "./EditorialRanking.vue?vue&type=style&index=0&id=32507532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32507532",
  null
  
)

export default component.exports